import request from '@/util/request';
import qs from 'qs';

// 分页
export const getPageList = (params, options) =>
  request.get('/api/shunt/meter/permission/page', Object.assign({}, options, { params }));

// 新增
export const add = (params, options) =>
  request.post('/api/shunt/meter/permission/save', params, options, {
    ContentType: 'application/json',
  });

// 修改
export const update = (params, options) =>
  request.post('/api/shunt/meter/permission/update', params, options, {
    ContentType: 'application/json',
  });

// 删除
export const remove = (params, options) =>
  request.post('/api/shunt/meter/permission/remove', qs.stringify(params), options);

// 获取用户授权区域
export const getAreaList = (params, options) =>
  request.get('/api/shunt/meter/permission/area-list', Object.assign({}, options, { params }));
